import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
// import BlogCard from "./BlogsCards";
import Particle from "../Particle";

// import leaf from "../../Assets/Projects/leaf.png";
// import emotion from "../../Assets/Projects/emotion.jpeg";
// import editor from "../../Assets/Projects/codeEditor.png";
// import chatify from "../../Assets/Projects/chatify.png";
// import suicide from "../../Assets/Projects/suicide.png";
import chat from "../../Assets/Projects/chat.gif";
import skincave from "../../Assets/Projects/sk5.jpg";
import cloudhome from "../../Assets/Projects/ch.jpg";
import photosearch from "../../Assets/Projects/ps.jpg";
import course from "../../Assets/Projects/course.png";
import cg from "../../Assets/Projects/cg.gif";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cloudhome}
              isBlog={false}
              title="Cloud Home"
              description="A rental marketplace for NYU students. This website is powered by AWS, React, and Python. "
              link="https://github.com/Zhang-Zecheng/CloudHome"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={skincave}
              isBlog={false}
              title="SkincAVE"
              description="A discount website allowing users to post deals and leave comments on products. Developed using Express.js and MongoDB"
              link="https://warm-basin-68943.herokuapp.com/"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chat}
              isBlog={false}
              title="Chat Software"
              description="A comprehensive online chatting software featuring user registration, login, real-time online status tracking, and
              message notification capabilities. Developed in Java."
              link="https://github.com/Roderickzzc/chat"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={photosearch}
              isBlog={false}
              title="Photo Album"
              description="A smart photo album that recognize the content and support image searching by keywords."
              link="http://frontend-github2-clientbucket-79iyno1c4lhs.s3-website-us-east-1.amazonaws.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cg}
              isBlog={false}
              title="Graphics Editor"
              description="A Graphics Editor that allows adding, deleting, transforming 2D and 3D objects. Implemented algorithms for mouse picking, ray tracing, shadow, reflection and lightening effects."
              link="https://github.com/nyu-cs-cy-6533-fall-2021/Graphics-Editor"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={course}
              isBlog={false}
              title="Course Selection System"
              description="A course selection system that allows student to add, drop, and swap courses. Developed in React and Django."
              link="https://github.com/Zhang-Zecheng/course-selection-system"
            />
          </Col>

          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
